
import { TabsContent } from "@/components/ui/tabs";
import { FormStep } from "@/components/listings/filters/FilterSchema";
import PropertyInformationStep from "./PropertyInformationStep";
import PropertyDetailsStep from "./PropertyDetailsStep";
import LocationStep from "./LocationStep";
import MediaStep from "./MediaStep";
import ContactStep from "./ContactStep";
import TitleDescriptionStep from "./TitleDescriptionStep";
import ReviewStep from "./ReviewStep";
import { useListingWizardContext } from "@/context/ListingWizardContext";
import { getStepTabValue } from "./utils/formUtils";

const FormStepContent = () => {
  const { form, draftListing } = useListingWizardContext();
  
  return (
    <>
      <TabsContent value="step-0">
        <PropertyInformationStep form={form} />
      </TabsContent>
      
      <TabsContent value="step-1">
        <PropertyDetailsStep form={form} />
      </TabsContent>
      
      <TabsContent value="step-2">
        <LocationStep form={form} />
      </TabsContent>
      
      <TabsContent value="step-3">
        <MediaStep form={form} />
      </TabsContent>
      
      <TabsContent value="step-4">
        <ContactStep form={form} />
      </TabsContent>
      
      <TabsContent value="step-5">
        <TitleDescriptionStep form={form} />
      </TabsContent>
      
      <TabsContent value="step-6">
        <ReviewStep formValues={form.getValues()} draftListing={draftListing} />
      </TabsContent>
    </>
  );
};

export default FormStepContent;
